import { createAsyncThunk } from "@reduxjs/toolkit";
import referralApi from 'api/referralApi';
import { formatQueryParams } from "helpers/format";
import 'react-toastify/dist/ReactToastify.css';

export const getRequestWithdraws = createAsyncThunk("Withdraw", async (params: any = {}) => {
  try {
    const response = await referralApi.withdraws(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getWithdraw =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await referralApi.getWithdraw(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const updateReward = async (id: string | number, data: any = {}) => {
  try {
    const response = await referralApi.putWithdraw(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
